export const initCardsSocial = () => {
	const components = Array.from(document.querySelectorAll('section.cards-social'));
	const breakpoint = 956;
	
	if ( components.length && window.innerWidth >= breakpoint )
	{
		components.forEach( ( component ) => {

			const cardsList = component.querySelector('ul.cards');
			const cards = cardsList.children;
			const totalCardsCount = cards.length;
			const desktopCardsCount = 3;

			const getRandomInt = (min, max) => {
				min = Math.ceil(min);
				max = Math.floor(max);
				return Math.floor(Math.random() * (max - min)) + min;
			}

			if ( totalCardsCount > desktopCardsCount )
			{
				const updateCard = ( cardNumber ) => {

					const card = cards[cardNumber];
					const nextCard = cards[cardNumber + desktopCardsCount];
					card.classList.remove( 'current' );
					nextCard.classList.add( 'current' );

					setTimeout( () => {
						const oldCard = cardsList.replaceChild( nextCard, card );
						cardsList.appendChild( oldCard );
					}, 1000 );

				}
	
				let delay = getRandomInt( 2000, 4000 );

				let timerId = setTimeout( function update() {
					updateCard( getRandomInt( 0, desktopCardsCount ));
					
					delay = getRandomInt( 2000, 4000 );
					timerId = setTimeout( update, delay );
					
				}, delay );
			}
		});
	}
}